const ugcPersonas = [
	{
		path: '/ai/ugc-personas/list',
		name: 'ai-ugc-personas-list',
		component: () => import('@/views/ai/ugc-personas/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,profiles',
		},
	},
]

export default ugcPersonas
